import React, {Component} from 'react';
import {Route, Switch, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import routes from './routes';
import PrivateRoute from "./PrivateRoute";
import withAnalytics, {initAnalytics} from 'react-with-analytics';
import {getActiveLanguage, withLocalize} from "react-localize-redux";
import translations from './translations_routes';

initAnalytics(process.env.REACT_APP_GOOGLE_ANALYTICS);

class Router extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    render() {
        return (
            <Switch>
                {routes.map((route, index) => {
                    if (route.private) {
                        return (
                            <PrivateRoute
                                key={index}
                                path={route.path}
                                exact={route.exact}
                                component={route.main}
                            />
                        );
                    } else {
                        return (
                            <Route
                                key={index}
                                path={route.path}
                                exact={route.exact}
                                component={route.main}
                            />
                        );
                    }
                })}
            </Switch>
        );
    }
}

const mapStateToProps = (state) => ({
    currentLanguage: getActiveLanguage(state.localize).code
});

export default withRouter(withAnalytics(connect(mapStateToProps, {})(withLocalize(Router))));


// WEBPACK FOOTER //
// ./src/app/router/Router.js